import React from 'react'

export default class Loader extends React.Component {
  render(){
    const className = `lds-ring ${ ''}`
    return (
      <div className={className}><div></div><div></div><div></div><div></div></div>
    )
  }
}